
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reciters",
      function () {
        return require("private-next-pages/reciters/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reciters"])
      });
    }
  